import { render, staticRenderFns } from "./mechanism-list.vue?vue&type=template&id=1e35d064&scoped=true&"
import script from "./mechanism-list.vue?vue&type=script&lang=js&"
export * from "./mechanism-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e35d064",
  null
  
)

export default component.exports